import getSelectedTableView from "./getSelectedTableView";
import getComputedSelectedRowKeysSize, { getComputedSelectedRowKeysSizeForTable, } from "./getComputedSelectedRowKeysSize";
import getListViewStore from "../store/Store";
import { owaComputedFn } from "owa-computed-fn";

/**
 * Computed counterparts of `isSingleItemSelection` and `isMultipleSelection`,
 * for call sites gated on 'fwk-ml-reduce-render-scope'.
 *
 * The default predicates use `getComputedSelectedRowKeysSize`, which resolves
 * selection from the active secondary reading pane tab when enabled. The plain
 * selectors only read `selectedRowKeys`.
 */
const getComputedIsSingleItemSelection: () => boolean = owaComputedFn(function getComputedIsSingleItemSelection(): boolean {
    return (!getSelectedTableView()?.selectedGroupHeaders.size &&
        getComputedSelectedRowKeysSize() === 1);
});
export default getComputedIsSingleItemSelection;

export const getComputedIsMultipleSelection: () => boolean = owaComputedFn(function getComputedIsMultipleSelection(): boolean {
    return (!!getSelectedTableView()?.selectedGroupHeaders.size ||
        getComputedSelectedRowKeysSize() > 1);
});

export const getComputedIsSingleItemSelectionForTable: (tableViewId: string) => boolean = owaComputedFn(function getComputedIsSingleItemSelectionForTable(tableViewId: string): boolean {
    return (!getListViewStore().tableViews.get(tableViewId)?.selectedGroupHeaders.size &&
        getComputedSelectedRowKeysSizeForTable(tableViewId) === 1);
});

export const getComputedIsMultipleSelectionForTable: (tableViewId: string) => boolean = owaComputedFn(function getComputedIsMultipleSelectionForTable(tableViewId: string): boolean {
    return (!!getListViewStore().tableViews.get(tableViewId)?.selectedGroupHeaders.size ||
        getComputedSelectedRowKeysSizeForTable(tableViewId) > 1);
});
